import React from "react";
import { NewsworthyScrollbarsContainer, Heading, Box } from "@govlaunch/web";
import { BoxProps } from "@govlaunch/web/src/box/Box";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";
import { FormattedMessage } from "react-intl";
import StoryNewsworthyItem from "./StoryNewsworthyItem";

interface IStoryNewsworthyProps extends BoxProps {
  story: Pick<IStoryFieldsFragment, "newsworthy">;
  stacked: boolean;
}

export default function StoryNewsworthy({ story, stacked = false, ...props }: IStoryNewsworthyProps) {
  if (!story.newsworthy || story.newsworthy.length === 0) {
    return null;
  }

  return (
    <Box display="grid" {...props}>
      <Heading as="h2" color="gray.900" css={{ fontSize: 32, fontWeight: 600 }} mb={1}>
        <FormattedMessage defaultMessage="Newsworthy" id="JhItYg" />
      </Heading>

      <NewsworthyScrollbarsContainer mt={1} stacked={stacked}>
        {story.newsworthy.map((newsworthy) => {
          return (
            <StoryNewsworthyItem
              key={newsworthy.url || Math.random().toString(16)}
              isMobile={stacked}
              newsworthy={{
                url: newsworthy.url || "",
                description: newsworthy.description,
                favicon: newsworthy.favicon,
                title: newsworthy.title || "",
                siteName: newsworthy.siteName || "",
              }}
            />
          );
        })}
      </NewsworthyScrollbarsContainer>
    </Box>
  );
}
